import React, { Component } from 'react';
import {connect} from 'react-redux';
import AgentsDetails from './AgentsDetails';
import AgentsMonitorWithService from './AgentsMonitorWithService';

class AgentsMonitor extends Component {
	constructor(props) {
    super(props);
    this.state = {
      //activeView: 'AgentsMonitorWithService',
    };
  }

	render() {
    const {
      activeMonitorView,
      searchFilter
    } = this.props;
		return (
      <div>
        {activeMonitorView == 'AgentsMonitorWithService' && <AgentsMonitorWithService
          searchFilter={searchFilter}
        />}
        {activeMonitorView == 'AgentsDetails' && <AgentsDetails
          searchFilter={searchFilter}
        />}
      </div>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				agentInfo: state.agentInfo,
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
    };
}

export default connect(mapStateToProps)(AgentsMonitor);



// WEBPACK FOOTER //
// ./src/agent/AgentsMonitor.js